<template>
  <div class="fav-mask" v-if="display">
    <transition>
      <div class="fav-modal__wrap" v-if="display">
        <div class="modal-header" v-if="type">{{ title }}</div>
        <div class="modal-body">
          <div
            class="fav-wrap"
            v-for="(item, index) in favsList"
            :key="index"
            @click.capture="handleClick(item)"
          >
            <div class="fav-name">
              <n-icon icon="iconwenjianjia-hei">{{ item.name }}</n-icon>
            </div>
            <div class="fav-count">
              <!-- <span>{{ item.count }}</span> -->
              <n-checkbox v-model="item._selected"></n-checkbox>
            </div>
          </div>
        </div>
        <div class="fav-input" v-if="type==1">
          <svg class="icon" aria-hidden="true" @click="handleFavName">
            <use xlink:href="#iconplus"></use>
          </svg>
          <input
            type="text"
            placeholder="请输入收藏夹名称"
            v-model="favname"
            maxlength="20"
            @keyup.enter="handleFavName"
          />
          <span :class="favname.length >= 20 ? 'error' : ''"
            >{{ favname.length }} / 20</span
          >
        </div>
        <div class="fav-input" v-else @click="type=1">
          新建收藏夹
        </div>
        <div class="error errorMsg">
          <span v-if="errMsg.code == '4000'">{{ errMsg.msg}}</span>
        </div>
        <div class="modal-footer">
          <n-button @click="handleOk">确定</n-button>
          <n-button type="default" @click="handleCancel">取消</n-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    err: {
      type: Object,
      default() {
        return {
          code: 2000,
          msg: "文件夹名称已存在",
        };
      },
    },
    favs: {
      default: () => {
        return [
          { id: 1, name: "默认收藏夹1", count: 100 },
          { id: 2, name: "默认收藏夹2", count: 100 },
        ];
      },
    },
    title: {
      default: "添加到收藏夹",
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type:1,
      disabled:true,
      errMsg: this.err,
      favname: "",
      display: this.show,
      selected: "",
      favsList: [
      ],
    };
  },
  created() {

  },
  computed: {},
  watch: {
    favs: function (value, oldValue) {
      this.favsList = value;
    },
    show: function (value, oldValue) {
      this.display = value;
    },
    favname: {
      handler(val) {
        if (val.length >= 20) {
          this.errMsg = {
            code:'4000',
            msg:'文件夹名称长度不能大于20'
          }
        } else {
            this.errMsg = {
            code:'2000',
            msg:''
          }
        }
      },
    },
    deep:true,
  },
  methods: {
    //创建收藏夹名称
    handleFavName() {
      if (!this.favname) {
        this.$message.error("收藏夹名称不能为空");
        return;
      }
      var _self = this;
      this.$axios.api.favoritesCreate({name: this.favname}, function (res) {
        if (res.code == 1) {
          _self.$message.success("提交成功，谢谢！");
          _self.favsList = res.data.favorites;
          _self.favname = '';
        } else {
          _self.$message.error("提交失败，请重新尝试！");
        }
      });
    },
    //选择收藏夹
    handleClick(item) {
      this.favsList.forEach((i) => {
        if (i.id == item.id) {
          this.$set(i, "_selected", true);
          this.selected = item;
        } else {
          this.$set(i, "_selected", false);
        }
      });
    },
    handleCancel() {
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("cancel");
    },
    handleOk() {
      // this.$emit("update:show", false);
      this.$emit("ok", this.selected);
    },
    handleClose() {
      console.log("close");
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.fav-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);

  .fav-modal__wrap {
    width: 474px;
    border-radius: 6px;
    position: relative;
    background-color: #fff;
    top: 200px;
    left: 50%;
    transform: translate(-50%, 0);

    > .modal-header {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      width: 100%;
      height: 52px;
      line-height: 52px;
      text-align: center;
      color: #fff;
      font-size: 20px;
      background-color: $primaryColor;
      user-select: none;
    }
    .modal-body {
      padding: 12px 0px;
      width: 100%;
      height: 336px;
      overflow-y: scroll;

      .fav-wrap {
        cursor: pointer;
        padding: 0 32px;
        color: #333333;
        display: flex;
        font-size: 18px;
        justify-content: space-between;
        align-items: center;
        height: 56px;

        > .fav-name {
          // width: 200px;
        }

        > .fav-count {
          > span {
            font-size: 18px;
            margin-right: 6px;
          }
        }

        &:hover {
          background-color: #eeeeee;
        }
      }

      &::-webkit-scrollbar-button {
        //   background:#333333;
        width: 100%;
        height: 10px;
        background-image: url("/galleryimage/scallbar.png");
        background-size: 100% 100%;
        background-position: center;
      }
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 16px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        box-shadow: inset 0 0 5px #eeeeee;
        background: #d3d0d0;
        background-image: url("/galleryimage/scallbar.png");
        background-size: 10px 10px;
        height: 10px;
        width: 10px;
        background-repeat: no-repeat;
        background-position: center;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px #ededed;
        background: #ededed;
      }
    }

    .fav-input {
      width: 100%;
      height: 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 2px solid #bbbbbb;
      padding: 0 32px;

      color: #bbbbbb;
      font-size: 32px;

      > img {
        width: 30px;
        height: 30px;
      }
      > input {
        width: 74%;
        height: 100%;
        font-size: 18px;
        padding: 0 6px;
      }
      > span {
        font-size: 18px;
      }
    }
    .error {
      color: #fa1d47;
    }
    .errorMsg {
      padding: 6px 74px;
      font-size: 18px;

      color: #fa1d47;
      width: 100%;
      height: 18px;
      margin-bottom: 18px;
    }
    .modal-footer {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 22px;
      .n-button {
        margin: 0 30px;
        line-height: 40px;
        height: 40px;
        width: 120px;
      }
    }
  }
}
</style>
